var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('sf-data-table',{ref:"resultList",attrs:{"selection":"","paging":"","excel":"","columns":_vm.columns,"rows":_vm.resultList,"pageUnit":_vm.groups.pageUnit,"pageArray":_vm.screen.pageArray,"totalSize":_vm.groups.totalSize,"currentPage":_vm.groups.currentPage},on:{"changedPage":_vm.changedPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }